import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Compromiso } from 'src/app/shared/models/compromiso.model';
import { CompromisoService } from 'src/app/shared/services/compromiso.service';

@Component({
  selector: 'app-community-commitments-alt',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss'],
})
export class CommunityCommitmentsAltComponent implements OnInit {
  compromisosList: Compromiso[] = [];
  id?: string;

  currentFilter?: string;
  image?: string;
  
  get compromisosFiltrados(): Compromiso[] {
    return this.compromisosList.filter(
      compromiso => compromiso.community === this.currentFilter
    );
  }

  constructor(
    private compromisoService: CompromisoService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];

      if (this.id == 'fibras') {
        this.currentFilter = 'Fibras';
        this.image = 'assets/img/ui/logo-fibras.webp';
      } else if (this.id == 'impact-trade') {
        this.currentFilter = 'Impact Trade';
        this.image =
          'https://test.aleph.work/files/cms/fibras/elementos/1100/5f174398-caee-4fe2-acd2-2ece5d768a8c.webp';
      } else if (this.id == 'origen') {
        this.currentFilter = 'Origen';
        this.image =
          'https://test.aleph.work/files/cms/fibras/elementos/1204/42bcaeec-5dcb-4680-9994-1f0aaffd2c89.webp';
      }

      this.loadCompromisos();
    });
  }

  loadCompromisos(): void {
    this.compromisoService.getCompromisos(null).subscribe((data: any) => {
      this.compromisosList = data.commitments;
    });
  }

  setFilter(community: string) {
    this.currentFilter = community;
  }

  trackByCode(index: number, compromiso: Compromiso): any {
    return compromiso.code;
  }
}
